/**
 * The speed ramp used to color a racing line: slow green → fast red.
 *
 * Lives here rather than inside TrackMap because two very different renderers
 * draw the same line — the Google Maps polyline in the app, and the inline SVG
 * baked into the public track pages at build time (see
 * scripts/build-track-pages.mjs, which imports this from Node). Two copies of a
 * color ramp drift, and a visitor comparing the static map with the live one
 * would see the same corner in two different colors.
 */
export function speedColor(speed, minSpeed, maxSpeed) {
  if (speed == null) return '#888';
  const t = Math.max(0, Math.min(1, (speed - minSpeed) / (maxSpeed - minSpeed)));
  if (t < 0.5) return `rgb(${Math.round(t * 2 * 255)},200,30)`;
  return `rgb(255,${Math.round((2 - t * 2) * 255)},0)`;
}
